import { Injectable } from "@angular/core";
import { forkJoin, map, Observable } from "rxjs";
import { PolicyService } from "./policy.service";
import { QuotationService } from "./quotation.service";
import { RequestTypesService } from "./request-types.service";
import { AgreementContactUs } from "../models/agreement-contact-us.model";
import { RequestType } from "../models/request-types.model";
import { Guid } from "guid-typescript";
import { ContactUsHelper } from "../helpers/contact-us.helper";
import { Quotation } from "../models/quotation";
import { Policy } from "../models/policy";
import { AgreementTypes } from "../enums/agreement-types";
import { MemberAgreements } from "@shared/models/member-agreements.model";

@Injectable({
  providedIn: "root",
})
export class ContactDataService {
  constructor(
    private readonly policyService: PolicyService,
    private readonly quotationService: QuotationService,
    private readonly requestTypesService: RequestTypesService
  ) {}

  loadMemberAgreements(): Observable<MemberAgreements> {
    return forkJoin([this.policyService.getPolicies(), this.quotationService.getQuotations()]).pipe(
      map(([policies, quotations]) => {
        return {
          policies,
          quotations,
          agreements: this.processAgreements(policies, quotations),
        };
      })
    );
  }

  private processAgreements(policies: Policy[], quotations: Quotation[]): AgreementContactUs[] {
    if (policies) {
      policies = ContactUsHelper.sortByCreationDate<Policy>(policies);
    }

    if (quotations) {
      quotations = ContactUsHelper.sortByCreationDate<Quotation>(quotations);
    }
    return [
      ...(policies || []).map(p => this.createAgreement(p, AgreementTypes.Policy)),
      ...(quotations || []).map(q => this.createAgreement(q, AgreementTypes.Quotation)),
    ];
  }

  private createAgreement(item: Policy | Quotation, type: AgreementTypes): AgreementContactUs {
    return {
      id: item.id,
      reference: item.reference,
      agreementType: type,
    };
  }

  getRequestTypes(agreementId: Guid, agreementType: number): Observable<RequestType[]> {
    if (agreementType === AgreementTypes.Policy) {
      return this.requestTypesService.getPolicyRequestTypesWithReasons(agreementId);
    } else {
      return this.requestTypesService.getQuotationRequestTypesWithReasons(agreementId);
    }
  }
}
